import OnboardingPageContent from "@/app/signup/onboarding/page";

export default function WelcomeDashboardPage() {
  return <OnboardingPageContent />;
}
